<template>
  <b-nav-item-dropdown right no-caret class="header-dropdown">
    <template #button-content>
      <img src="~static/img/avatars/9.jpg" class="img-avatar" alt="admin@bootstrapmaster.com" />
    </template>
    <b-dropdown-header tag="div" class="text-left header-dropdown__header">
      <strong>{{ userFullName }}</strong>
    </b-dropdown-header>
    <b-dropdown-item v-b-modal:change-password-modal class="header-dropdown__item">
      <font-awesome-icon :icon="['fas', 'key']" />
      Schimbă parola
      <change-password-modal id="change-password-modal" />
    </b-dropdown-item>
    <b-dropdown-item class="header-dropdown__item" role="button" @click="goToAdmin">
      <font-awesome-icon :icon="['fa', 'user']" />
      Admin Panel
    </b-dropdown-item>
    <b-dropdown-item class="header-dropdown__item" @click="logout">
      <font-awesome-icon :icon="['fa', 'lock']" />
      Deconectare
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
  import { AbilityBuilder } from '@casl/ability'
  import ChangePasswordModal from '@/components/auth/ChangePasswordModal'

  export default {
    name: 'HeaderDropdown',
    components: {
      ChangePasswordModal,
    },

    computed: {
      userFullName() {
        return this.$auth.user.name
      },
      adminUrl() {
        // Build admin URL based on environment variables with safe fallbacks
        const appUrl = process.env.APP_URL
        const baseUrl = process.env.BASE_URL

        // Helper to ensure protocol is present
        const withProtocol = (u) => {
          if (!u) return null
          if (/^https?:\/\//i.test(u)) return u
          return `https://${u}`
        }

        // 1) Prefer APP_URL if provided
        let origin = withProtocol(appUrl)

        // 2) Else derive origin from BASE_URL by stripping a trailing /api
        if (!origin && baseUrl) {
          try {
            const url = new URL(baseUrl)
            // Remove trailing '/api' if present
            if (url.pathname.endsWith('/api')) {
              url.pathname = url.pathname.replace(/\/api$/i, '') || '/'
            }
            origin = url.origin + (url.pathname === '/' ? '' : url.pathname)
          } catch (e) {
            // Fallback: if BASE_URL is not a full URL, try to prefix https://
            const fallback = withProtocol(baseUrl)
            try {
              const url2 = new URL(fallback)
              if (url2.pathname.endsWith('/api')) {
                url2.pathname = url2.pathname.replace(/\/api$/i, '') || '/'
              }
              origin = url2.origin + (url2.pathname === '/' ? '' : url2.pathname)
            } catch (e2) {
              // ignore, will fallback below
            }
          }
        }

        // 3) Final fallback to current origin
        if (!origin && process.client && typeof window !== 'undefined') {
          origin = window.location.origin
        }

        return `${origin}/admin`
      },
    },
    methods: {
      async logout() {
        await this.$auth.logout()
        this.updateAbilities()
        await this.$router.replace({
          name: 'auth-index-signin',
        })
      },
      goToAdmin() {
        window.open(this.adminUrl, '_blank')
      },
      updateAbilities() {
        const { rules } = new AbilityBuilder()
        this.$ability.update(rules)
      },
      openChangePasswordDialog() {
        alert('test')
      },
    },
  }
</script>

<style lang="scss">
  .header-dropdown {
    .dropdown-menu {
      width: 200px;
    }
  }
</style>
